<template>
      <customer-payment-receipt-file
          v-if="(order.payment.method != 'CASH' && order.payment.method != 'DEBIT') && order.payment.receiptFile === null"
          :order="order"
          @orderModified="onOrderModified"
      />
      <order-payment v-else :order="order" :total-amount="order.totalAmount" vertical></order-payment>
</template>

<script>
import OrderPayment from "@/modules/delivery/components-core/shared/OrderPayment/OrderPayment.vue";
import CustomerPaymentReceiptFile from "@/modules/delivery/components-core/customer/CustomerPaymentReceiptFile/CustomerPaymentReceiptFile.vue";

export default {
  name: "ShowOrderPayment",
  components: {CustomerPaymentReceiptFile, OrderPayment},
  props: {
    order: {type: Object}
  },
  methods: {
    onOrderModified(order){
      console.log("ShowOrderPayment onOrderModified", order)
      this.$emit('orderModified',order)
    }
  }
}
</script>

<style scoped>

</style>
